// WEB-ONLY achieved (D1-backed, keyed by SAP).
// a fixed 3-STAGE process per vessel; vessel identity (SAP / model / name) comes from the overview.
// each stage has a per-vessel 3-state status plus an optional comment and date
// 3 stages mirror the vessel milestones that auto-advance them (see the notify wiring):
// added to GRP → GRP status green → deck cap fitted.
export const DECK_STAGES = ['Added to GRP', 'GRP status green', 'Deck cap fitted'];
//# sourceMappingURL=deck.js.map